export enum TemplatesEmail {
  CREATE = '/templates/email/create',
  EDIT = '/templates/email/edit',
}
